import React from 'react';
import styles from './styles.module.css';

export default function HtmlText({
  content,
  className = '',
  extraClass = '',
}: {
  content?: string;
  className?: string;
  extraClass?: string;
}) {
  return (
    <div
      className={`${className ? className : `${styles.text} ${extraClass}`} `}
      dangerouslySetInnerHTML={{ __html: content || '' }}
    ></div>
  );
}
